// Desktop opens via the shared <component-drawer> / <drawer-button> system (assets/theme.js),
// the same right-side drawer used by the cart and search drawers — no bespoke open/close here.
// This file only wires the shared form behaviour used by every variant.

// Mobile trigger button — toggles the separate panel (different DOM location) via aria-controls.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-market-selector-mobile-trigger]');
  if (!trigger) return;
  event.preventDefault();
  event.stopPropagation();
  const panelId = trigger.getAttribute('aria-controls');
  const panel = panelId && document.getElementById(panelId);
  if (!panel) return;
  const isOpen = trigger.getAttribute('aria-expanded') === 'true';
  if (isOpen) {
    trigger.setAttribute('aria-expanded', 'false');
    // Keep [hidden] off so the slide-down transition can play.
    // The base CSS applies `visibility: hidden` after the transform transition,
    // which removes the panel from the a11y tree once it's offscreen.
    panel.classList.remove('is-open');
  } else {
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
    // Next frame so the browser picks up the removed [hidden] before the class transition
    requestAnimationFrame(() => panel.classList.add('is-open'));
  }
});

// An explicit country/language choice in the selector means the visitor has made a
// deliberate decision — suppress the IP country-mismatch popup for the rest of the
// session (shares the sessionStorage flag that assets/market-mismatch.js checks/sets),
// so changing language no longer re-triggers the popup on the next page load.
const dismissMarketMismatch = () => {
  try {
    sessionStorage.setItem('marketMismatchDismissed', '1');
  } catch (error) {
    /* storage unavailable — nothing to persist */
  }
};

// Language shortcuts AND the country itself (AAS-4784) — set the form's hidden
// country_code + locale_code synchronously before the browser performs the native
// form submit. Both carry data-country-code/data-locale-code, so they share this
// handler; the country's locale is resolved in Liquid (first language, or the next
// one when you're already on that country, so clicking again toggles). Works for
// both desktop and mobile variants.
document.addEventListener('click', (event) => {
  const btn = event.target.closest('.market-selector__language, .market-selector__country--btn');
  if (!btn) return;
  const { countryCode, localeCode } = btn.dataset;
  const form = btn.form;
  if (!form || !countryCode || !localeCode) return;
  const countryInput = form.querySelector('input[name="country_code"]');
  const localeInput = form.querySelector('input[name="locale_code"]');
  if (countryInput) countryInput.value = countryCode;
  if (localeInput) localeInput.value = localeCode;
  dismissMarketMismatch();
});

// Redirect markets — external stores. Clicking the row navigates away (not a form submit).
document.addEventListener('click', (event) => {
  const target = event.target.closest('[data-redirect-url]');
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  const url = target.dataset.redirectUrl;
  if (url) {
    dismissMarketMismatch();
    window.location.href = url;
  }
});

// Upgrade redirect-market ISO codes to full country names via Intl.DisplayNames.
// The Liquid renders the ISO code (e.g. "JP") as a no-JS fallback; here we swap in
// the localized region name (e.g. "Japan") for any name span carrying data-country-code.
(() => {
  if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function') return;
  let regionNames;
  try {
    regionNames = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' });
  } catch (error) {
    return;
  }
  document.querySelectorAll('.market-selector__country-name[data-country-code]').forEach((span) => {
    const code = span.dataset.countryCode;
    if (!code) return;
    try {
      const name = regionNames.of(code);
      if (name && name !== code) span.textContent = name;
    } catch (error) {
      /* keep the ISO fallback */
    }
  });
})();
